import { apiBaseUrlLocal } from "./AppConfig";

export const exportScans = async (admin_data, options) => {
  const response = await fetch(apiBaseUrlLocal + "admin/scans/export", {
    method: "POST",
    body: new URLSearchParams({
      user_id: admin_data.admin_id,
      app_token: admin_data.token,
      start_date: options.startDate,
      end_date: options.endDate,
      winners: JSON.stringify(options.checkedWinners),
      selected_sources: JSON.stringify(options.selectedSources),
      selected_users: JSON.stringify(options.selectedUsers),
    }),
  });
  if (response.status === 200) {
    const data = await response.json();
    console.log(data);
    return data;
  } else return false;
};
